import { ButtonProps, ModalProps } from "antd";
import React from "react";

export interface CustomModalProps extends ModalProps {
  footerLeft?: string;
  isOkDanger?: boolean;
  isCancelDanger?: boolean;
  leftFooterElements?: React.ReactElement;
  justifyBody?: string;
  alignBody?: string;
  customTitle?: React.ReactNode;
  customFooter?: React.ReactNode;
  onAdditional?: any;
  isNotShowX?: boolean;
  isNoFooter?: boolean;
  isOkDisabled?: boolean;
  isCancelDisabled?: boolean;
  isOneBtn?: boolean;
}
export const defaultButtonProps: ButtonProps = {
  size: "large",
  style: {
    borderRadius: "4px",
    fontFamily: "Noto Sans CJK KR",
    fontStyle: "normal",
    fontWeight: "normal",
    fontSize: "16px",
    lineHeight: "24px",
  },
};
export interface AlertModalProps {
  onOk?: any;
  title: string;
  width?: number;
  contents: string | React.ReactNode;
  footer?: React.ReactElement;
  okText?: string;
  isDanger?: boolean;
}
export interface ConfirmModalProps extends AlertModalProps {
  onCancel?: any;
  contents: string | React.ReactNode;
  cancelText?: string;
}
